export enum TicketTypes {
  Public = 'public',
  Private = 'private',
  Internal = 'internal',
  Maintenance = 'maint_auto',
  Anomaly = 'anomaly',
  Standard = 'standard'
}
export enum TicketActionAttachmentTypes {
  Message = 'message',
  Attachment = 'attachment',
  AttachmentImage = 'image',
  AttachmentVideo = 'video',
  AttachmentDocument = 'document',
  Loader_indeterminate = 'loader_indeterminate',
  Error = 'error',
  Loader = 'loader',
  NewGroup = 'new_group'
}

export enum TicketCharacters {
  Plumbing = 1,
  Electricity = 2,
  HomeAppliance = 3,
  Heating = 4,
  Glaziery = 5,
  Other = 6
}



// WEBPACK FOOTER //
// ./src/common/enums/ticket-types.enum.ts